import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';
import { JourneyHub } from '@addmile/backend-client';

import { count } from '../../count';
import { describeIssue } from '../../issues';
import { Selection } from '../../selection';
import IssueList from '../IssueList/IssueList';

const SHOWN_ISSUES = 8;

interface CantPublishModalProps {
  journey?: JourneyHub;
  onClose: () => void;
  onSelect?: (target: Selection) => void;
}

const CantPublishModal = ({ journey, onClose, onSelect }: CantPublishModalProps) => {
  const issues = journey?.issues.map((issue) => describeIssue(issue, journey)) ?? [];
  const hidden = issues.length - SHOWN_ISSUES;

  return (
    <Popup isOpen={!!journey} handleClose={onClose} maxWidth={480}>
      <Text.Big weight="bold" className="mb-2">
        Can’t publish yet
      </Text.Big>
      <Text.Regular className="text-neutral-60 mb-4">
        {count(issues.length, 'thing')} to fix before <b>{journey?.title || 'this journey'}</b> can
        go online:
      </Text.Regular>
      <IssueList
        issues={issues.slice(0, SHOWN_ISSUES)}
        onSelect={
          onSelect &&
          ((target) => {
            onClose();
            onSelect(target);
          })
        }
      />
      {hidden > 0 && (
        <Text.Regular className="text-neutral-50 mt-4">
          …and {hidden} more — the full list is on the journey’s page.
        </Text.Regular>
      )}
      <div className="flex justify-end mt-6">
        <Button label="OK" size="s" className="!w-20" onClick={onClose} />
      </div>
    </Popup>
  );
};

export default CantPublishModal;
